import { User } from "../types";
import i18n from "../i18n";
import { isTrialExpired } from "../utils/trial";
import dayjs from "dayjs";

/*
  Return formatted Subscription Type
  TRIAL -> Prova
  VDA -> VDA
  PT -> PT
*/
export const getSubscriptionType = (subscriptionType: string) =>
  subscriptionType === "TRIAL" ? "Prova" : subscriptionType;

export const getSubscriptionStatus = (customer: User): string => {
  let status = i18n.t(
    "screens.client.customerTableHead.subscriptionState.disactive"
  );

  if (!customer.stripeID && isTrialExpired(customer.createdAt)) {
    status = i18n.t(
      "screens.client.customerTableHead.subscriptionState.trial-expired"
    );
  } else if (customer.subscription_type === "TRIAL") {
    status = i18n.t("screens.client.customerTableHead.subscriptionState.trial");
  } else if (
    !customer.subscription_disactivation_date ||
    (customer.subscription_status === "completed" &&
      customer.subscription_type !== "PT") ||
    (customer.subscription_type === "PT" &&
      dayjs().isBefore(dayjs(customer.subscription_disactivation_date)))
  ) {
    status = i18n.t(
      "screens.client.customerTableHead.subscriptionState.active"
    );
  } else if (
    (customer.subscription_status === "canceled" ||
      customer.subscription_type === "PT") &&
    dayjs().isAfter(dayjs(customer.subscription_disactivation_date))
  ) {
    status = i18n.t(
      "screens.client.customerTableHead.subscriptionState.inactive"
    );
  } else if (dayjs(customer.subscription_disactivation_date).isAfter(dayjs())) {
    status = i18n.t(
      "screens.client.customerTableHead.subscriptionState.cancelled"
    );
  }

  return status;
};
